export enum ImageVariant {
    ORIGINAL = 'ORIGINAL',
    FULL = 'FULL',
    THUMBNAIL = 'THUMBNAIL'
}
